import React, { useState, useEffect } from "react";
import "./HomeFirstThinkerSection.css";
import icon1 from "../assets/home_icons/Home Page_website-30.png";
import icon4 from "../assets/home_icons/Home Page_website-31.png";
import icon2 from "../assets/home_icons/Home Page_website-32.png";
import icon3 from "../assets/home_icons/Icon1.png";
import flame from "../assets/home_icons/WhatsApp Video 2026-03-02 at 12.49.10 PM.mp4";
import { getLanguage } from 'react-switch-lang';
import en from '../en.json';
import ma from '../ma.json';

const translationData = { en: en, mr: ma };

const HomeFirstThinkerSection = () => {
  const [language, setLanguage] = useState(() => getLanguage() || 'en');
  const t = (key) => {
    const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
    return translationData[langKey]?.[key] || '';
  };
  useEffect(() => {
    const checkLang = () => {
      const current = getLanguage() || 'en';
      setLanguage(prev => prev !== current ? current : prev);
    };
    checkLang();
    const interval = setInterval(checkLang, 500);
    window.addEventListener('storage', checkLang);
    return () => { clearInterval(interval); window.removeEventListener('storage', checkLang); };
  }, []);

  return (
    <section className="ft-section">
      <div className="ft-wrapper">
        <div className="ft-card">

          {/* HEADER */}
          <div className="ft-header">
            <p className="ft-small-title">{t('ft_label')}</p>
            <h2 className="ft-main-title">{t('ft_name')}</h2>
          </div>

          {/* CONTENT ROW */}
          <div className="ft-content">

            {/* LEFT */}
            <div className="ft-left">
              <div className="ft-points">

                <div className="ft-item">
                  <div className="ft-img-wrapper">
                    <img src={icon1} alt="icon" />
                  </div>
                  <p>{t('ft_item1')}</p>
                </div>

                <div className="ft-item">
                  <div className="ft-img-wrapper">
                    <img src={icon2} alt="icon" />
                  </div>
                  <p>{t('ft_item2')}</p>
                </div>

                <div className="ft-item">
                  <div className="ft-img-wrapper">
                    <img src={icon3} alt="icon" />
                  </div>
                  <p>{t('ft_item3')}</p>
                </div>

                <div className="ft-item">
                  <div className="ft-img-wrapper">
                    <img src={icon4} alt="icon" />
                  </div>
                  <p>{t('ft_item4')}</p>
                </div>

              </div>

              <hr className="ft-divider" />

              <p className="ft-quote">
                {t('ft_quote')}
              </p>
            </div>

            {/* RIGHT */}
            <div className="ft-right">
              <div className="ft-video-wrap">
                <video
                  className="candle-video"
                  src={flame}
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFirstThinkerSection;